import { C1IconButton } from 'c1ui'
import { EditIcon } from 'components/core/action-icons/edit-icon'
import { FC } from 'react'
import { useIntl } from 'react-intl'

type C1EditButtonProps = {
    onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}

export const C1EditButton: FC<C1EditButtonProps> = ({ onClick }) => {
    const intl = useIntl()

    return <C1IconButton
        color="inherit"
        variant="text"
        onClick={onClick}
        aria-label={intl.formatMessage({ id: 'component-edit-button', defaultMessage: 'Edit' })}
        sx={({
            height: '24px',
            width: '24px',
            opacity: 0.5,

            '&:hover': {
                backgroundColor: 'primary.extraLight',
                color: 'primary.main',
                opacity: 1,
            },
        })}
    >
        <EditIcon />
    </C1IconButton>
}
